import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import AttributeOptions from './AttributeOptions.js';
import CustomAlert from '../components/CustomAlert.js';

class PersonalInfoForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            has_couple: false,
            has_children: false,
            has_children_in_school: false,
            children_options:[{id:0 , name:'0'}, {id:1 , name:'1'}, {id:2 , name:'2'}, {id:3 , name:'3'}, {id:4 , name:'4'}, {id:5 , name:'5'}, {id:6 , name:'6'},{id:7 , name:'más de 6'}, {id:8 , name:'No desea contestar'}],
            children_filtered_options:[],
            people_in_house_filtered_options:[]
        };
        this.checkIfHasChildren = this.checkIfHasChildren.bind(this);
        this.checkIfHasChildrenInSchool = this.checkIfHasChildrenInSchool.bind(this);
        this.checkIfHasCouple = this.checkIfHasCouple.bind(this);
        this.filterPeopleInHouseOptions = this.filterPeopleInHouseOptions.bind(this);
        this.changeMaritalStatusFields = this.changeMaritalStatusFields.bind(this);
        this.peopleInHouse = [{id: 0, name: 'Solo'},{id: 1, name: 'Padres'},{id: 2, name: 'Esposa e Hijos'},{id: 3, name: 'Pareja e Hijos'},{id: 4, name: 'Comparten con 3eros'},{id: 5, name: 'Hijos'},{id: 6, name: 'Otros'}]
        this.peopleInHouseByMaritalStatus = {
            0: [0, 1, 4, 5, 6],
            1: [2, 1, 4, 6],
            2: [3, 1, 4, 6],
            3: [0, 1, 4, 5, 6],
            4: [0, 1, 4, 5, 6],
            5: [2, 1, 4, 6]
        }
    }

    checkIfHasChildren(value){
        if(['false','0','8'].includes(value)){
            this.setState({has_children: false});
            this.props.deleteReduxFormField('dependent_children');
            this.props.deleteReduxFormField('children_in_school');
            this.props.deleteReduxFormField('children_institution_type');
        }else{
            const children_filtered_options = this.state.children_options.filter((option) => option.id <= parseInt(value,10))
            this.setState({has_children: true,
                           children_filtered_options: children_filtered_options});
        }
    }

    checkIfHasChildrenInSchool(value){
        if(['false','0'].includes(value)){
            this.setState({has_children_in_school: false});
            this.props.deleteReduxFormField('children_in_school');
        }else{
            this.setState({has_children_in_school: true});
        }
    }

    checkIfHasCouple(value){
        if([1,2].includes(parseInt(value,10))){
            this.setState({has_couple: true});
        }else{
            this.setState({has_couple: false});
            this.props.deleteReduxFormField('couple_has_employment');
        }
    }

    filterPeopleInHouseOptions(value){
        this.setState({
            people_in_house_filtered_options: this.peopleInHouse.filter(item => this.peopleInHouseByMaritalStatus[value].includes(item.id))
        });
    }

    changeMaritalStatusFields(value){
        this.checkIfHasCouple(value);
        this.filterPeopleInHouseOptions(value);
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const marital_status = [{id: 0, name: 'Soltero'},{id: 1, name: 'Casado'},{id: 2, name: 'Convive'},{id: 3, name: 'Divorciado / Separado'},{id: 4, name: 'Viudo'},{id: 5, name: 'Otro'}]
        const couple_has_employment = [{id:0 , name:'Sí'}, {id:1 , name:'No'}]
        const people_in_house = [{id: 0, name: 'Solo'},{id: 1, name: 'Padres'},{id: 2, name: 'Esposa e Hijos'},{id: 3, name: 'Pareja e Hijos'},{id: 4, name: 'Comparten con 3eros'},{id: 5, name: 'Hijos'},{id: 6, name: 'Otros'}]
        const breadwinner = [{id:0 , name:'Sí'}, {id:1 , name:'No'}]
        const house_condition = [{id:0 , name:'Propietario'}, {id:1 , name:'Alquila'}, {id:2 , name:'Otro'}]
        const bathrooms = [{id:0 , name:'1'}, {id:1 , name:'2'}, {id:2 , name:'3'}, {id:3 , name:'4'}, {id:4 , name:'5'}, {id:5 , name:'6'},{id:6 , name:'más de 6'}, {id:7 , name:'No desea contestar'}]
        const bedrooms = [{id:0 , name:'1'}, {id:1 , name:'2'}, {id:2 , name:'3'}, {id:3 , name:'4'}, {id:4 , name:'más de 4'}, {id:5 , name:'No desea contestar'}]
        const children_institution_type = [{id:0 , name:'Pública'}, {id:1 , name:'Privada'}, {id:2 , name:'Mixta'}, {id:3 , name:'No desea contestar'}]

        const couple_field = (<div className="form-group">
                                    <AttributeOptions name="couple_has_employment" defaultValue="¿Tu pareja trabaja?" label="¿Tu pareja trabaja?" attributeName='couple_has_employment' attributeOptions={couple_has_employment}/>
                                </div>);
        const dependent_children_field = (<div className="form-group">
                                            <AttributeOptions name="dependent_children" defaultValue="¿Hijos que viven con vos?" label="¿Hijos que viven con vos?" attributeName='dependent_children' attributeOptions={this.state.children_filtered_options}/>
                                          </div>);
        const children_in_school_field = (<div className="form-group">
                                            <AttributeOptions name="children_in_school" defaultValue="¿Hijos que van a la escuela?" label="¿Hijos que van a la escuela?" attributeName='children_in_school' attributeOptions={this.state.children_filtered_options} onChange={this.checkIfHasChildrenInSchool}/>
                                          </div>);
        const children_institution_type_field = (<div className="form-group">
                                                    <AttributeOptions name="children_institution_type" defaultValue="¿Escuela pública o privada?" label="¿Escuela pública o privada?" attributeName='children_institution_type' attributeOptions={children_institution_type}/>
                                                 </div>);
        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_personal_info" description="Personal info"/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.savePersonalInfo)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <AttributeOptions name="marital_status" defaultValue="¿Cúal es tu situación?" label="¿Cúal es tu situación?" attributeName='marital_status' attributeOptions={marital_status} onChange={this.changeMaritalStatusFields}/>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    {this.state.has_couple && couple_field}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <AttributeOptions name="people_in_house" defaultValue="¿Con quién vivís?" label="¿Con quién vivís?" attributeName='people_in_house' attributeOptions={this.state.people_in_house_filtered_options}/>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <AttributeOptions name="house_condition" defaultValue="¿Sos propietario o alquilás?" label="¿Sos propietario o alquilás?" attributeName='house_condition' attributeOptions={house_condition}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="breadwinner" defaultValue="¿Sos único sostén económico?" label="Sos único sostén económico de hogar/familia?" attributeName='breadwinner' attributeOptions={breadwinner}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <AttributeOptions name="bathrooms" defaultValue="¿Cuántos baños tenés?" label="¿Cuántos baños tenés?" attributeName='bathrooms' attributeOptions={bathrooms}/>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <AttributeOptions name="bedrooms" defaultValue="¿Cúantos dormitorios tenés?" label="¿Cúantos dormitorios tenés?" attributeName='bedrooms' attributeOptions={bedrooms}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <AttributeOptions name="children" defaultValue="¿Cuántos hijos tenés?" label="¿Cuántos hijos tenés?" attributeName='children' attributeOptions={this.state.children_options} onChange={this.checkIfHasChildren}/>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    {this.state.has_children && dependent_children_field}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    {this.state.has_children && children_in_school_field}
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    {this.state.has_children && this.state.has_children_in_school && children_institution_type_field}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

PersonalInfoForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'marital_status', required: true},
                                  {name: 'couple_has_employment', required: true},
                                  {name: 'people_in_house', required: true},
                                  {name: 'house_condition', required: true},
                                  {name: 'breadwinner', required: true},
                                  {name: 'bathrooms', required: true},
                                  {name: 'bedrooms', required: true},
                                  {name: 'children', required: true},
                                  {name: 'dependent_children', required: true},
                                  {name: 'children_in_school', required: true},
                                  {name: 'children_institution_type', required: true}])
PersonalInfoForm = TopScrolleable(PersonalInfoForm);

PersonalInfoForm = reduxForm({
    form: 'PersonalInfoForm', // a unique name for this form
    validate
})(PersonalInfoForm);

PersonalInfoForm = withAuthControl(PersonalInfoForm);

export default PersonalInfoForm;


/** WEBPACK FOOTER **
 ** ./src/components/PersonalInfoForm.js
 **/